export default __webpack_public_path__ + "static/media/rabbit-blue.24f3af85.svg";